import Hammer from "hammerjs";

const managers = new WeakMap();

const capitalize = (value) =>
  value.charAt(0).toUpperCase() + value.slice(1);

const configureRecognizer = (manager, eventName) => {
  let recognizer = manager.get(eventName);
  if (recognizer) return recognizer;

  const Recognizer = Hammer[capitalize(eventName)];
  if (!Recognizer) return null;

  recognizer = new Recognizer();
  recognizer.recognizeWith(manager.recognizers);
  manager.add(recognizer);
  return recognizer;
};

const bindHandler = (element, binding) => {
  const eventName = binding.arg;
  if (!eventName || typeof binding.value !== "function") return;

  let state = managers.get(element);
  if (!state) {
    state = {
      manager: new Hammer.Manager(element),
      handlers: new Map(),
    };
    managers.set(element, state);
  }

  if (!configureRecognizer(state.manager, eventName)) return;

  const previousHandler = state.handlers.get(eventName);
  if (previousHandler) {
    state.manager.off(eventName, previousHandler);
  }

  state.manager.on(eventName, binding.value);
  state.handlers.set(eventName, binding.value);
};

const unbindHandler = (element, eventName) => {
  const state = managers.get(element);
  if (!state) return;

  const handler = state.handlers.get(eventName);
  if (handler) {
    state.manager.off(eventName, handler);
    state.handlers.delete(eventName);
  }

  if (state.handlers.size === 0) {
    state.manager.destroy();
    managers.delete(element);
  }
};

export default {
  mounted: bindHandler,
  updated(element, binding) {
    if (binding.value !== binding.oldValue) {
      bindHandler(element, binding);
    }
  },
  beforeUnmount(element, binding) {
    unbindHandler(element, binding.arg);
  },
};
